import BigNumber from 'bignumber.js';
import { TFunction } from 'i18next';
import { Money } from '~/types/money';
import { VATCode } from '~/types/vat-bookkeeping';
import { formatPercentageLimitingDecimals as formatPercentage } from '~/utils/formatNumber';
import { isZero, multiplyMoney } from '../money';

export const vatCodeIndeductibility = (vatCode: VATCode) => {
  return 100 - (vatCode.vatDeductibility ?? 100);
};

export const calcIndeductibleAmount = (amount: Money, vatCode: VATCode) => {
  if (isZero(amount)) {
    return amount;
  }

  const rate = vatCodeIndeductibility(vatCode) / 100;
  return multiplyMoney(amount, rate);
};

export const calcDeductibleAmount = (amount: Money, vatCode: VATCode) => {
  if (isZero(amount)) {
    return amount;
  }

  const rate = (vatCode.vatDeductibility ?? 100) / 100;
  return multiplyMoney(amount, rate);
};

export function buildVatKey(vatPercentage: number | string, vatNature?: string | null): string {
  const parsedPercentage = BigNumber(vatPercentage).dp(0);
  if (parsedPercentage.isZero()) {
    return vatNature ?? '0';
  }
  return parsedPercentage.toFixed(0).toString();
}

export const buildVatCodeDescription = (code: VATCode, t: TFunction<'bookkeeping', 'inputs.vat_code_field'>) => {
  const descriptionParts = [];

  if (code.vatNature) descriptionParts.push(code.vatNature);
  descriptionParts.push(`${t('percentage')}: ${formatPercentage(code.vatPercentage)}`);
  descriptionParts.push(`${t('detraction_percentage')}: ${formatPercentage(code.vatDeductibility ?? 100)}`);

  return descriptionParts.join(' | ');
};
